import criacao_de_identidade_marca from "../../../../assets/images/other_soluctions_images/criacao_de_identidade_marca.png";
import hospedagem_site from "../../../../assets/images/other_soluctions_images/hospedagem_site.png";
import marketing_digital from "../../../../assets/images/other_soluctions_images/ui_ux.png";
import postagem_em_lojas from "../../../../assets/images/other_soluctions_images/criacao_de_app.png";

export const otherSolutionsMapper = {
    title: "Soluções",
    sectionTitle: "Soluções para \n seus problemas",

    largeCards: [
        {
            id: 'ui-ux',
            image: marketing_digital,
            title: "Design UI/UX",
            description: "Interfaces intuitivas e jornadas claras para aumentar conversão, retenção e satisfação.",
            hasButton: true,
        },
        {
            id: 'hospedagem',
            image: hospedagem_site,
            title: "Hospedagem de Sites e Softwares",
            description: "Hospedagem gerenciada com segurança, backups e monitoramento para manter tudo no ar.",
            hasButton: true,
            customId: 'card_website_hosting',
            customContentId: 'card_website_hosting_content',
        },
    ],

    mediumCards: [
        {
            id: 'gestao-projetos',
            image: criacao_de_identidade_marca,
            title: "Gestão de Projetos",
            description: "Gestão baseada em dados para priorizar, reduzir riscos e garantir entregas com previsibilidade.",
        },
        {
            id: 'apps',
            image: postagem_em_lojas,
            title: "Criação de Aplicativos Personalizados",
            description: "Apps Android e iOS sob medida — do MVP ao lançamento, com integrações e evolução contínua.",
            isPublicStore: true,
        },
    ],

    smallCards: [
        {
            id: 'marketing',
            title: "Marketing Digital",
            description: "Estratégia e performance para gerar demanda, atrair clientes e vender com consistência.",
        },
        {
            id: 'identidade',
            title: "Identidade de Marca",
            description: "Logo, paleta e guia visual para uma marca consistente e reconhecível em todos os canais.",
        },
    ],
};
